export const LAST_SUCCESSFUL_REPORTS_SYNC_KEY = 'msales_lastReportsSyncTime';

// Stored reports are only read offline, so refreshing them after every sent
// order just re-downloads the month's orders. Once per window is enough.
export const REPORTS_REFRESH_AFTER_SYNC_MS = 30 * 60 * 1000;

export const readLastReportsSync = (userId) => {
  if (!userId) return null;
  try {
    return localStorage.getItem(`${LAST_SUCCESSFUL_REPORTS_SYNC_KEY}:${userId}`);
  } catch {
    return null;
  }
};

export const shouldRefreshReportsAfterOperationsSync = (
  lastSyncIso,
  now = Date.now(),
) => {
  const last = Date.parse(lastSyncIso);
  if (!Number.isFinite(last) || last > now) return true;
  return now - last >= REPORTS_REFRESH_AFTER_SYNC_MS;
};
